export default {
  isLoggedIn: false,
  id: null,
  name: null,
  email: null,
  isMounted: null,
  windowWidth: 0,
};
